import { listDrugs } from './index';

import { drugsRouteStore } from '../domain/store';

export default (e) => {
  drugsRouteStore.setValue('filterValue', e.target.value);
  drugsRouteStore.setValue('currentPage', 1);
  return listDrugs();
};
